export default __webpack_public_path__ + "static/media/logo.9104ff74.png";